import { render } from "./Course.vue?vue&type=template&id=882cc702"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"

import "./Course.vue?vue&type=style&index=0&id=882cc702&lang=scss"
script.render = render

export default script